export enum API_CHOICE {
  CITY = 'city',
  PRELIMINARY_CONTRACTS = 'preliminaryContracts',
  INNO_PROFESSIONS = 'innoProfessions',
  HERSTELLER = 'hersteller',
}

export const ApiChoiceSource: {
  [key in API_CHOICE]: string;
} = {
  [API_CHOICE.CITY]: 'loadCitiesByPlz',
  [API_CHOICE.PRELIMINARY_CONTRACTS]: 'getPreliminaryContracts',
  [API_CHOICE.INNO_PROFESSIONS]: 'loadProfessions',
  [API_CHOICE.HERSTELLER]: 'loadHersteller',
};

/*
  Define a mapping to transform API responses into ApiChoiceValue

  e.g. response {"status":"success","data":[{"id":1652,"postcode":33699,"city":"Bielefeld"}]}
  mapper: id::city

  results in ApiChoiceValue {
    label: Bielefeld
    value: 1652,
  }

  ps.: YES, Bielefeld exists. 😝
 */
export const ApiChoiceMapper: {
  [key in API_CHOICE]: string;
} = {
  [API_CHOICE.CITY]: 'city::city',
  [API_CHOICE.PRELIMINARY_CONTRACTS]: 'label::links.self',
  [API_CHOICE.INNO_PROFESSIONS]: 'label::label',
  [API_CHOICE.HERSTELLER]: 'label::value',
};

export interface ApiChoice {
  type: API_CHOICE;
  requestParameters: string[];
  id: string;
}

export interface ApiChoiceValue {
  label: string;
  value: string;
  type?: string;
}

export interface ApiChoiceResponseItem {
  [key: string]: string;
}
